<div
  [ngClass]="{ 'pointer-event-none': !isEditing }"
  class="category-title d-flex justify-content-between"
  style="height: 45px; align-items: center; border-top-left-radius: 5px; border-top-right-radius: 5px">
  <div class="d-flex align-items-center">
    @if (!readOnly && !isProjectSetting) {
      <button
        type="button"
        class="checkbox-hyfn mx-2 ms-3"
        (click)="toggleSelectAll()"
        aria-label="Select all checkbox">
        <img
          [ngSrc]="getCheckboxImage()"
          class="checkbox-image"
          alt="Checkbox"
          width="23"
          height="23"
          style="padding-bottom: 6px" />
      </button>
    }
    @if (isProjectSetting) {
      <div class="toggle-switch header-toggle-switch">
        <input
          [checked]="isAllassetSelected()"
          [disabled]="isAllSelectedFromOther()"
          (click)="selecteAllasset()"
          (keydown.enter)="selecteAllasset()"
          type="checkbox"
          [id]="funnel"
          class="toggle-input" />
        <label [for]="funnel" class="toggle-label"></label>
      </div>
    }
    <span [class.ms-3]="readOnly" class="m-0">
      {{ funnel | translate }}
    </span>
  </div>
  @if (!isProjectDashboard) {
    <div class="d-flex align-items-center" style="position: relative; right: 9px">
      <button type="button" (click)="addNewAsset()" class="d-flex m-0 add-button">
        <img ngSrc="assets/svg/asset-add.svg" width="15" height="15" alt="Add Icon" />
        <span class="m-1">{{ 'new' | translate | uppercase }}</span>
      </button>
      <div [ngClass]="{ 'pointer-none': !hasSelectedAssets() }" class="mx-2 align-item-center">
        <div ngbDropdown autoCloseDropdown class="dropdown" container="body" placement="bottom-right" autoClose="true">
          <div class="dropdown-toggle-container" ngbDropdownToggle>
            <div class="three-dot-icon">
              <span class="bg-white"></span>
              <span class="bg-white"></span>
              <span class="bg-white"></span>
            </div>
          </div>

          <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
            <div class="col options">
              <span class="menu-arrow"></span>
              @if (hasSelectedAssets()) {
                <button
                  type="button"
                  class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
                  (click)="toggleHideSelectedAssets()">
                  <img
                    [ngSrc]="
                      areAllSelectedHidden() ? 'assets/svg/eye-active-asset.svg' : 'assets/svg/eye-hide-asset.svg'
                    "
                    width="14"
                    height="14"
                    alt="Visibility Icon"
                    style="color: #181e39" />
                  <span class="ms-2 f-10 _700 text-uppercase">{{ areAllSelectedHidden() ? 'Activate' : 'Hide' }}</span>
                </button>
              }
              @if (hasSelectedAssets()) {
                <button
                  type="button"
                  class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
                  (click)="duplicateSelectedAssets()">
                  <img ngSrc="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                  <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                </button>
              }
              @if (hasSelectedAssets() && canDeleteAllSelected()) {
                <button
                  type="button"
                  class="col pointer p-0 d-flex align-items-center py-1 ps-2 hover-text border-0 bg-transparent text-start w-100"
                  (click)="deleteSelectedAssets()">
                  <img ngSrc="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                  <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
